import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Job} from "../shared/job.model";
import {AlertController, Events, NavController} from "ionic-angular";
import {TranslateService} from "@ngx-translate/core";
import {JobService} from "../shared/job.service";
import {ToastService} from "../../../app/core/toast.service";
import {JobPage} from "../job.page";
import {RoleService} from "../../../app/core/role.service";
import {JobControlsService} from "./job-controls.service";

@Component({
  selector: 'app-job-controls',
  templateUrl: 'job-controls.component.html'
})
export class JobControlsComponent implements OnInit, OnDestroy {
  @Input('job') job: Job;
  roleSub: any;
  role: string;
  buttons;

  constructor(private alertCtrl: AlertController,
              private translate: TranslateService,
              private jobService: JobService,
              private toast: ToastService,
              private events: Events,
              private nav: NavController,
              private jobControlsService: JobControlsService,
              private roleService: RoleService) {
    this.buttons = this.jobControlsService.buttons;
  }

  ngOnInit() {
    this.roleSub = this.roleService.getRole()
      .subscribe((role) => this.role = role);
  }

  ngOnDestroy(){
    this.roleSub.unsubscribe();
  }

  showAcceptModal(job) {
    let confirm = this.alertCtrl.create({
      title: this.translate.instant('job.accept_job'),
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('global.accept'),
          handler: () => {
            confirm.dismiss()
              .then(() => this.accept(job));
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  showRejectModal(job) {
    let prompt = this.alertCtrl.create({
      title: this.translate.instant('job.reject_job'),
      message: this.translate.instant('job.reject_reason'),
      inputs: [
        {
          name: 'reason'
        }
      ],
      buttons: [
        this.translate.instant('global.cancel'),
        {
          text: this.translate.instant('job.reject_job'),
          handler: (inputData) => {
            if (!inputData.reason) {
              return false;
            }
            prompt.dismiss()
              .then(() => this.reject(job, inputData.reason));
            return false;
          }
        }
      ]
    });
    prompt.present();
  }

  goToPreview(){
    this.events.publish('job_edit_form:submitted');
  }

  save() {
    this.jobService[this.job.id ? 'updateJob' : 'saveJob'](this.job)
      .subscribe(
        res => {
          this.nav.pop();
          this.nav.push(JobPage, {id: res.id});
          this.toast.show(res.message);
          // this.toastPublishedService.show(this.job.id ? 'updated' : 'published');
        }
      );
  }

  private reject(job, reason) {
    this.jobService.rejectJob(job.id, reason)
      .subscribe(
        (res) => {
          this.toast.show(res.message);
          this.events.publish('job:updated');
        }
      );
  }

  private accept(job) {
    this.jobService.acceptJob(job)
      .subscribe(
        (res) => {
          this.toast.show(res.message);
          this.events.publish('job:updated');
        },
        (error) => {
          // Job has been updated meanwhile
          if (error.status === 409) {
            this.events.publish('job:updated');
          }
          throw error;
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/job/job-controls/job-controls.component.ts